var _trackingLogOffVariab, _trackingOnMountVaria, _trackingCloseVariabl, _trackingCustomerServ;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import { ACTIVATION_FORM, ACTIVATION_ERROR, ACTIVATION_CTA, ACTIVATION_HAS_ACCESS, ACTIVATION_NO_SUBSCRIPTION, ACTIVATION_NO_ACCESS, ACTIVATION_SUCCESS, MULTIBRAND_ACTIVATION, MULTIBRAND_SUCCESS } from './constants/steps';
/* eslint-disable */

var baseVariables = {
  access_loginshown: true,
  access_walltype: 'subscription',
  event_category: 'conversionwall'
};
export var trackingLogOffVariables = (_trackingLogOffVariab = {}, _trackingLogOffVariab[ACTIVATION_HAS_ACCESS] = function (params) {
  return _extends({}, baseVariables, {
    event_action: 'click-signout',
    event_label: '/conversion/activate/ACT33'
  }, params);
}, _trackingLogOffVariab);
export var trackingOnMountVariables = (_trackingOnMountVaria = {}, _trackingOnMountVaria[ACTIVATION_CTA] = function (params) {
  return _extends({}, baseVariables, {
    event_action: 'show',
    event_noninteraction: 'true',
    event_label: '/conversion/activate/ACT10'
  }, params);
}, _trackingOnMountVaria[ACTIVATION_FORM] = function (params) {
  return _extends({}, baseVariables, {
    event_action: 'show',
    event_label: '/conversion/activate/ACT20'
  }, params);
}, _trackingOnMountVaria[ACTIVATION_SUCCESS] = function (params) {
  return _extends({}, baseVariables, {
    event_action: 'show',
    event_label: '/conversion/activate/ACT30'
  }, params);
}, _trackingOnMountVaria[ACTIVATION_NO_SUBSCRIPTION] = function (params) {
  return _extends({}, baseVariables, {
    event_action: 'show',
    event_label: '/conversion/activate/ACT31'
  }, params);
}, _trackingOnMountVaria[ACTIVATION_NO_ACCESS] = function (params) {
  return _extends({}, baseVariables, {
    event_action: 'show',
    event_label: '/conversion/activate/ACT32'
  }, params);
}, _trackingOnMountVaria[ACTIVATION_HAS_ACCESS] = function (params) {
  return _extends({}, baseVariables, {
    event_action: 'show',
    event_label: '/conversion/activate/ACT33'
  }, params);
}, _trackingOnMountVaria[ACTIVATION_ERROR] = function (params) {
  return _extends({}, baseVariables, {
    event_action: 'show',
    event_label: '/conversion/activate/ACT34'
  }, params);
}, _trackingOnMountVaria[MULTIBRAND_ACTIVATION] = function (params) {
  return _extends({}, baseVariables, {
    event_action: 'show',
    event_label: '/conversion/activate/MultiBrandActivation'
  }, params);
}, _trackingOnMountVaria[MULTIBRAND_SUCCESS] = function (params) {
  return _extends({}, baseVariables, {
    event_action: 'show',
    event_label: '/conversion/activate/MultiBrandSuccess'
  }, params);
}, _trackingOnMountVaria);
export var trackingCloseVariables = (_trackingCloseVariabl = {}, _trackingCloseVariabl[ACTIVATION_CTA] = function (params) {
  return _extends({}, baseVariables, {
    event_action: 'click-close',
    event_label: '/conversion/activate/ACT10'
  }, params);
}, _trackingCloseVariabl[ACTIVATION_FORM] = function (params) {
  return _extends({}, baseVariables, {
    event_action: 'click-close',
    event_label: '/conversion/activate/ACT20'
  }, params);
}, _trackingCloseVariabl[ACTIVATION_SUCCESS] = function (params) {
  return _extends({}, baseVariables, {
    event_action: 'click-close',
    event_label: '/conversion/activate/ACT30'
  }, params);
}, _trackingCloseVariabl[ACTIVATION_NO_SUBSCRIPTION] = function (params) {
  return _extends({}, baseVariables, {
    event_action: 'click-close',
    event_label: '/conversion/activate/ACT31'
  }, params);
}, _trackingCloseVariabl[ACTIVATION_NO_ACCESS] = function (params) {
  return _extends({}, baseVariables, {
    event_action: 'click-close',
    event_label: '/conversion/activate/ACT32'
  }, params);
}, _trackingCloseVariabl[ACTIVATION_HAS_ACCESS] = function (params) {
  return _extends({}, baseVariables, {
    event_action: 'click-close',
    event_label: '/conversion/activate/ACT33'
  }, params);
}, _trackingCloseVariabl[ACTIVATION_ERROR] = function (params) {
  return _extends({}, baseVariables, {
    event_action: 'click-close',
    event_label: '/conversion/activate/ACT34'
  }, params);
}, _trackingCloseVariabl);
export var trackingCustomerServiceVariables = (_trackingCustomerServ = {}, _trackingCustomerServ[ACTIVATION_CTA] = function (params) {
  return _extends({}, baseVariables, {
    event_action: 'click-close',
    event_label: '/conversion/activate/ACT10'
  }, params);
}, _trackingCustomerServ[ACTIVATION_FORM] = function (params) {
  return _extends({}, baseVariables, {
    event_action: 'click-contact',
    event_label: '/conversion/activate/ACT20'
  }, params);
}, _trackingCustomerServ[ACTIVATION_SUCCESS] = function (params) {
  return _extends({}, baseVariables, {
    event_action: 'click-contact',
    event_label: '/conversion/activate/ACT30'
  }, params);
}, _trackingCustomerServ[ACTIVATION_NO_SUBSCRIPTION] = function (params) {
  return _extends({}, baseVariables, {
    event_action: 'click-contact',
    event_label: '/conversion/activate/ACT31'
  }, params);
}, _trackingCustomerServ[ACTIVATION_NO_ACCESS] = function (params) {
  return _extends({}, baseVariables, {
    event_action: 'click-contact',
    event_label: '/conversion/activate/ACT32'
  }, params);
}, _trackingCustomerServ[ACTIVATION_HAS_ACCESS] = function (params) {
  return _extends({}, baseVariables, {
    event_action: 'click-contact',
    event_label: '/conversion/activate/ACT33'
  }, params);
}, _trackingCustomerServ[ACTIVATION_ERROR] = function (params) {
  return _extends({}, baseVariables, {
    event_action: 'click-contact',
    event_label: '/conversion/activate/ACT34'
  }, params);
}, _trackingCustomerServ);
/* eslint-enable */